import { matchPath } from "react-router-dom";

import { REDIRECT_URLS } from "../../../globalConstants";

export const allowedOrigins = [
  { path: "/action-items", end: false },
  { path: "/client-detail/:clientId/*", end: false },
];

export function resolveReturnTarget(returnTo, fallback = REDIRECT_URLS.SEARCH) {
  const pathname = returnTo?.pathname ?? "";
  const isAllowed = allowedOrigins.some((p) => !!matchPath(p, pathname));
  if (!isAllowed) {
    return fallback;
  }
  return `${pathname}${returnTo?.search ?? ""}${returnTo?.hash ?? ""}`;
}
